export enum AppointmentResponseCode {
  Ok = 'ok',
  InternalError = 'internalError',
  LocationNotFound = 'locationNotFound',
  CategoryNotFound = 'categoryNotFound',
  EmployeeNotFound = 'employeeNotFound',
  GroupAppointmentNotFound = 'groupAppointmentNotFound',
  MinFutureBookingHoursNotMet = 'minFutureBookingHoursNotMet',
  TimeSlotNotAvailable = 'timeSlotNotAvailable',
  MaxAppointmentsPerWeekExceeded = 'maxAppointmentsPerWeekExceeded',
  MaxGroupAppointmentsPerWeekExceeded = 'maxGroupAppointmentsPerWeekExceeded',
  MaxAppointmentsExceeded = 'maxAppointmentsExceeded',
  MaxAppointmentFrequencyExceeded = 'maxAppointmentFrequencyExceeded',
  MinAdvanceCancellationHoursNotMet = 'minAdvanceCancellationHoursNotMet',
  MaxFutureBookingHoursExceeded = 'maxFutureBookingHoursExceeded',
  CategoryBookingConstraintsNotMet = 'categoryBookingConstraintsNotMet',
  EmployeeBookingConstraintsNotMet = 'employeeBookingConstraintsNotMet',
  GroupAppointmentBookedOut = 'groupAppointmentBookedOut',
  AppointmentNotFound = 'appointmentNotFound',
  PatientNotFound = 'patientNotFound',
  PatientNotAllowed = 'patientNotAllowed',
  AboMissing = 'aboMissing',
  DuplicatePatientRecords = 'duplicatePatientRecords'
}
